var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      ref: "previousConfigurtionExists",
      attrs: {
        id: "previousConfigurtionExists",
        title: _vm.$t("title"),
        "no-close-on-backdrop": "",
        okTitle: _vm.$t("ok"),
        cancelTitle: _vm.$t("cancel")
      },
      on: { ok: _vm.ok }
    },
    [_c("p", [_vm._v("\n  " + _vm._s(_vm.$t("text")) + "\n")])]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fea1dc5a", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fea1dc5a","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./WebApp/components/modals/PreviousConfigurationExistsModal.vue
// module id = 780
// module chunks = 0